import { useEffect, useMemo, useState } from "react";
import Head from "next/head";
import Link from "next/link";

import Section from "../../components/Section";
import SectionLayout from "../../components/[przyjaznedeklaracje]/_sectionLayout";

const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || "https://przyjazne-deklaracje.pl").replace(
	/\/$/,
	"",
);
const PAGE_PATH = "/pomoc-video";
const PAGE_URL = `${SITE_URL}${PAGE_PATH}`;

const THUMBNAIL_SRC_CACHE = new Map();
const THUMBNAIL_PENDING_CACHE = new Map();

const VIDEO_TAGS = [
	{ id: "IN-1", label: "IN-1" },
	{ id: "DN-1", label: "DN-1" },
	{ id: "DT-1", label: "DT-1" },
	{ id: "Nieruchomości", label: "Nieruchomości" },
	{ id: "Transport", label: "Transport" },
	{ id: "Dom", label: "Dom" },
	{ id: "Mieszkanie", label: "Mieszkanie" },
	{ id: "Działka", label: "Działka" },
];

const VIDEO_ARTICLES = [
	{
		fileName: "jak-poprawic-deklaracje-dn-1-przy-uzyciu-pliku-dek-instrukcja-krok-po-kroku.md",
		title:
			"Deklaracja DN-1 - jak szybko skorygować za pomocą pliku DEK? – instrukcja krok po kroku",
		description:
			"Masz plik DEK? Zobacz, jak w kilka minut przygotować korektę DN-1 bez wpisywania danych od nowa.",
		tags: ["DN-1", "Nieruchomości"],
		videoUrl: "https://www.youtube.com/watch?v=Q7ogGfTGESQ",
		duration: "1:32",
	},
	{
		fileName: "jak-przygotowac-deklaracje-dn-1-w-5-minut-instrukcja-krok-po-kroku.md",
		title:
			"Deklaracja DN-1? Zobacz, jak przygotować deklarację na podatek od nieruchomości w 5 minut",
		description:
			"Pierwszy raz korzystasz z Przyjaznych Deklaracji? Zacznij od tego filmu i zobacz, jak uprościć przygotowanie DN-1.",
		tags: ["DN-1", "Nieruchomości"],
		videoUrl: "https://www.youtube.com/watch?v=yZ7nNAwoxu4",
		duration: "1:32",
	},
	{
		fileName: "jak-przygotowac-deklaracje-dt-w-5-minut-instrukcja-krok-po-kroku.md",
		title:
			"Deklaracja DT-1? Zobacz, jak przygotować deklarację na podatek od środków transportowych w 5 minut",
		description:
			" Chcesz przygotować deklarację DT-1? Zobacz, jak wykorzystać Excel, aby szybko wygenerować deklarację i złożyć ją do urzędu.",
		tags: ["DT-1", "Transport"],
		videoUrl: "https://www.youtube.com/watch?v=pA2W6wqk0do",
		duration: "1:32",
	},
	{
		fileName: "jak-skorygowac-dn-1-przy-uzyciu-pliku-dek-i-excela-instrukcja-krok-po-kroku.md",
		title:
			"Deklaracja DN-1 - jak szybko skorygować za pomocą pliku DEK i Excela? – instrukcja krok po kroku",
		description:
			"Połącz Excel i plik DEK, aby przygotować korektę DN-1 jeszcze szybciej. Automatycznie uzupełnij dane i ogranicz pracę.",
		tags: ["DN-1", "Nieruchomości"],
		videoUrl: "https://www.youtube.com/watch?v=dbd7NCJHIw8",
		duration: "1:32",
	},
	{
		fileName: "jak-wypelnic-dn-1-przy-uzyciu-arkusza-excel-instrukcja-krok-po-kroku.md",
		title: "Podatek od nieruchomości - jak wypełnić DN-1 przy użyciu arkusza kalkulacyjnego Excel ",
		description:
			"Zobacz szczegółowy poradnik, jak wypełnić szablon Excel, dzięki któremu szybko przygotujesz deklarację DN-1.",
		tags: ["DN-1", "Nieruchomości"],
		videoUrl: "https://www.youtube.com/watch?v=BHLZOE1Ibco",
		duration: "1:32",
	},
	{
		fileName: "jak-wypelnic-formularz-in-1-dla-domu-instrukcja-krok-po-kroku.md",
		title: "Podatek od nieruchomości DOM. Jak wypełnić IN-1? Przykład",
		description:
			"Sprawdź, jak krok po kroku przygotować informację IN-1 dla domu i uniknąć najczęstszych błędów.",
		tags: ["IN-1", "Nieruchomości", "Dom"],
		videoUrl: "https://www.youtube.com/watch?v=eLxXLjd0bi4",
		duration: "1:32",
	},
	{
		fileName: "jak-wypelnic-formularz-in-1-dla-dzialki-instrukcja-krok-po-kroku.md",
		title: "Podatek od nieruchomości DZIAŁKA. Jak wypełnić IN-1? Przykład",
		description:
			"Masz działkę do zgłoszenia? Zobacz, jak szybko przygotować IN-1 i poprawnie uzupełnić wszystkie dane.",
		tags: ["IN-1", "Nieruchomości", "Działka"],
		videoUrl: "https://www.youtube.com/watch?v=hZFrYTDz8kM",
		duration: "1:32",
	},
	{
		fileName: "jak-wypelnic-formularz-in-1-dla-mieszkania-instrukcja-krok-po-kroku.md",
		title: "Podatek od nieruchomości MIESZKANIE. Jak wypełnić IN-1? Przykład",
		description:
			"Zobacz, jak bez stresu przygotować informację IN-1 dla mieszkania i w kilku krokach złożyć ją do urzędu.",
		tags: ["IN-1", "Nieruchomości", "Mieszkanie"],
		videoUrl: "https://www.youtube.com/watch?v=QJP3xGhl73E",
		duration: "1:32",
	},
	{
		fileName: "jak-zlozyc-korekte-deklaracji-dn-1-instrukcja-krok-po-kroku.md",
		title: "Jak złożyć korektę deklaracji DN-1? – instrukcja krok po kroku",
		description:
			"Chcesz poprawić deklarację DN-1? Sprawdź, jak wybrać najlepszy sposób i szybko przygotować korektę.",
		tags: ["DN-1", "Nieruchomości"],
		videoUrl: "https://www.youtube.com/watch?v=zlZhe9hqKy4",
		duration: "1:32",
	},
];

function extractYoutubeId(input) {
	if (!input) return "";

	if (/^[a-zA-Z0-9_-]{11}$/.test(input)) {
		return input;
	}

	try {
		const parsedUrl = new URL(input);

		if (parsedUrl.hostname.includes("youtu.be")) {
			const id = parsedUrl.pathname.replace("/", "").trim();
			return /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : "";
		}

		const v = parsedUrl.searchParams.get("v");

		if (v && /^[a-zA-Z0-9_-]{11}$/.test(v)) {
			return v;
		}

		const shortsMatch = parsedUrl.pathname.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
		if (shortsMatch?.[1]) return shortsMatch[1];

		const liveMatch = parsedUrl.pathname.match(/\/live\/([a-zA-Z0-9_-]{11})/);
		if (liveMatch?.[1]) return liveMatch[1];

		const embedMatch = parsedUrl.pathname.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
		if (embedMatch?.[1]) return embedMatch[1];
	} catch {}

	return "";
}

function getSlug(fileName) {
	return fileName.replace(/\.md$/, "");
}

function getArticleTitle(fileName) {
	const title = getSlug(fileName)
		.replace(/-/g, " ")
		.replace(/\bin 1\b/g, "IN-1")
		.replace(/\bdn 1\b/g, "DN-1")
		.replace(/\bdt\b/g, "DT-1")
		.replace(/\bdek\b/g, "DEK")
		.replace(/\bexcel\b/g, "Excel")
		.replace(/\bexcela\b/g, "Excela");

	return title.charAt(0).toUpperCase() + title.slice(1);
}

function getArticleDisplayTitle(article) {
	return article.title || getArticleTitle(article.fileName);
}

function getArticleUrl(fileName) {
	return `${SITE_URL}/abc-podatkow/${getSlug(fileName)}`;
}

function getAbsoluteUrl(url) {
	if (!url) return "";

	if (url.startsWith("http://") || url.startsWith("https://")) {
		return url;
	}

	if (url.startsWith("/")) {
		return `${SITE_URL}${url}`;
	}

	return `${SITE_URL}/${url}`;
}

function isCrawlableUrl(url) {
	return (
		typeof url === "string" &&
		(url.startsWith("http://") || url.startsWith("https://") || url.startsWith("/"))
	);
}

function durationToIsoDuration(duration) {
	if (!duration || typeof duration !== "string") {
		return undefined;
	}

	if (/^P/.test(duration)) {
		return duration;
	}

	const parts = duration.split(":").map((part) => Number(part));

	if (parts.some((part) => Number.isNaN(part))) {
		return undefined;
	}

	if (parts.length === 2) {
		const [minutes, seconds] = parts;
		return `PT${minutes}M${seconds}S`;
	}

	if (parts.length === 3) {
		const [hours, minutes, seconds] = parts;
		return `PT${hours}H${minutes}M${seconds}S`;
	}

	return undefined;
}

function isoDurationToReadableDuration(isoDuration) {
	if (!isoDuration || typeof isoDuration !== "string") {
		return "";
	}

	const match = isoDuration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);

	if (!match) {
		return "";
	}

	const hours = Number(match[1] || 0);
	const minutes = Number(match[2] || 0);
	const seconds = Number(match[3] || 0);

	if (hours > 0) {
		return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
	}

	return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

function getYoutubeThumbnailCandidates(videoId, customThumbnail) {
	const candidates = [];

	if (customThumbnail) {
		candidates.push(customThumbnail);
	}

	if (!videoId) {
		return candidates;
	}

	candidates.push(
		`https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`,
		`https://i.ytimg.com/vi_webp/${videoId}/maxresdefault.webp`,
		`https://i.ytimg.com/vi/${videoId}/hq720.jpg`,
		`https://i.ytimg.com/vi_webp/${videoId}/hq720.webp`,
		`https://i.ytimg.com/vi/${videoId}/sddefault.jpg`,
		`https://i.ytimg.com/vi_webp/${videoId}/sddefault.webp`,
		`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`,
		`https://i.ytimg.com/vi_webp/${videoId}/hqdefault.webp`,
		`https://i.ytimg.com/vi/${videoId}/mqdefault.jpg`,
		`https://i.ytimg.com/vi/${videoId}/default.jpg`,
	);

	return [...new Set(candidates.filter(Boolean))];
}

function loadImage(src) {
	return new Promise((resolve, reject) => {
		const img = new Image();

		img.onload = () => {
			resolve({
				src,
				width: img.naturalWidth,
				height: img.naturalHeight,
			});
		};

		img.onerror = () => {
			reject(new Error(`Nie udało się załadować miniaturki: ${src}`));
		};

		img.decoding = "async";
		img.src = src;
	});
}

function withTimeout(promise, ms = 2500) {
	return Promise.race([
		promise,
		new Promise((_, reject) => {
			window.setTimeout(() => reject(new Error("Timeout ładowania miniaturki")), ms);
		}),
	]);
}

function isBadYoutubeThumbnail(result) {
	if (!result) return true;

	if (result.width <= 120 || result.height <= 90) {
		return true;
	}

	if (result.width < 320) {
		return true;
	}

	return false;
}

function getThumbnailCacheKey(videoId, customThumbnail) {
	return `${videoId || ""}::${customThumbnail || ""}`;
}

async function resolveBestThumbnail(videoId, customThumbnail) {
	const cacheKey = getThumbnailCacheKey(videoId, customThumbnail);

	if (THUMBNAIL_SRC_CACHE.has(cacheKey)) {
		return THUMBNAIL_SRC_CACHE.get(cacheKey);
	}

	if (THUMBNAIL_PENDING_CACHE.has(cacheKey)) {
		return THUMBNAIL_PENDING_CACHE.get(cacheKey);
	}

	const promise = (async () => {
		const candidates = getYoutubeThumbnailCandidates(videoId, customThumbnail);

		if (candidates.length === 0) {
			THUMBNAIL_SRC_CACHE.set(cacheKey, "");
			return "";
		}

		for (const candidate of candidates) {
			try {
				const result = await withTimeout(loadImage(candidate));

				if (!isBadYoutubeThumbnail(result)) {
					THUMBNAIL_SRC_CACHE.set(cacheKey, result.src);
					return result.src;
				}
			} catch {}
		}

		const fallbackSrc = candidates[candidates.length - 1] || "";

		THUMBNAIL_SRC_CACHE.set(cacheKey, fallbackSrc);

		return fallbackSrc;
	})();

	THUMBNAIL_PENDING_CACHE.set(cacheKey, promise);

	try {
		return await promise;
	} finally {
		THUMBNAIL_PENDING_CACHE.delete(cacheKey);
	}
}

function getBestYoutubeThumbnailFromSnippet(thumbnails) {
	if (!thumbnails) {
		return "";
	}

	return (
		thumbnails.maxres?.url ||
		thumbnails.standard?.url ||
		thumbnails.high?.url ||
		thumbnails.medium?.url ||
		thumbnails.default?.url ||
		""
	);
}

function normalizeArticle(article) {
	const videoUrl = article.videoUrl || article.url || article.src || "";
	const videoId = article.videoId || extractYoutubeId(videoUrl);
	const fallbackThumbnailUrl = videoId ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg` : "";

	return {
		...article,
		videoUrl,
		videoId,
		thumbnailUrl: article.thumbnailUrl || article.thumbnail || article.poster || "",
		fallbackThumbnailUrl,
		embedUrl: article.embedUrl || (videoId ? `https://www.youtube.com/embed/${videoId}` : ""),
		isoDuration: article.isoDuration || durationToIsoDuration(article.duration),
	};
}

function getStructuredThumbnailUrl(article) {
	return article.thumbnailUrl || article.fallbackThumbnailUrl || "";
}

function canCreateVideoObject(article) {
	const thumbnailUrl = getStructuredThumbnailUrl(article);

	return Boolean(
		article.uploadDate &&
		isCrawlableUrl(thumbnailUrl) &&
		(isCrawlableUrl(article.videoUrl) ||
			isCrawlableUrl(article.embedUrl) ||
			isCrawlableUrl(article.contentUrl)),
	);
}

function buildStructuredData(articles) {
	const itemListId = `${PAGE_URL}#lista-filmow`;

	const collectionPage = {
		"@type": "CollectionPage",
		"@id": `${PAGE_URL}#webpage`,
		url: PAGE_URL,
		name: "Pomoc video – Przyjazne Deklaracje",
		description:
			"Filmy instruktażowe i artykuły pomocnicze dotyczące formularzy IN-1, DN-1, DT-1 oraz podatków lokalnych.",
		inLanguage: "pl-PL",
		isPartOf: {
			"@type": "WebSite",
			"@id": `${SITE_URL}/#website`,
			name: "Przyjazne Deklaracje",
			url: SITE_URL,
		},
		mainEntity: {
			"@id": itemListId,
		},
	};

	const itemList = {
		"@type": "ItemList",
		"@id": itemListId,
		name: "Lista filmów pomocy",
		numberOfItems: articles.length,
		itemListElement: articles.map((article, index) => ({
			"@type": "ListItem",
			position: index + 1,
			url: getArticleUrl(article.fileName),
			name: getArticleDisplayTitle(article),
		})),
	};

	const videoObjects = articles.filter(canCreateVideoObject).map((article) => {
		const videoObject = {
			"@type": "VideoObject",
			"@id": `${getArticleUrl(article.fileName)}#video`,
			name: getArticleDisplayTitle(article),
			description: article.description,
			thumbnailUrl: [getAbsoluteUrl(getStructuredThumbnailUrl(article))],
			uploadDate: article.uploadDate,
			url: getArticleUrl(article.fileName),
			inLanguage: "pl-PL",
			publisher: {
				"@type": "Organization",
				name: "Przyjazne Deklaracje",
				logo: {
					"@type": "ImageObject",
					url: "https://przyjazne-deklaracje.pl/resources/images/logo/przyjazne-deklaracje/logo-desktop.svg",
				},
			},
		};

		const isoDuration = article.isoDuration || durationToIsoDuration(article.duration);

		if (isoDuration) {
			videoObject.duration = isoDuration;
		}

		if (article.contentUrl) {
			videoObject.contentUrl = getAbsoluteUrl(article.contentUrl);
		}

		if (article.embedUrl) {
			videoObject.embedUrl = getAbsoluteUrl(article.embedUrl);
		}

		return videoObject;
	});

	return {
		"@context": "https://schema.org",
		"@graph": [collectionPage, itemList, ...videoObjects],
	};
}

function serializeJsonLd(data) {
	return JSON.stringify(data).replace(/</g, "\\u003c");
}

function ThumbImage({ videoId, alt, className, customThumbnail }) {
	const cacheKey = useMemo(() => {
		return getThumbnailCacheKey(videoId, customThumbnail);
	}, [videoId, customThumbnail]);

	const cachedSrc = THUMBNAIL_SRC_CACHE.get(cacheKey) || "";

	const [src, setSrc] = useState(cachedSrc);
	const [isLoading, setIsLoading] = useState(!cachedSrc);

	useEffect(() => {
		let cancelled = false;

		async function pickThumbnail() {
			if (!videoId && !customThumbnail) {
				setSrc("");
				setIsLoading(false);
				return;
			}

			const alreadyCachedSrc = THUMBNAIL_SRC_CACHE.get(cacheKey);

			if (alreadyCachedSrc) {
				setSrc(alreadyCachedSrc);
				setIsLoading(false);
				return;
			}

			setIsLoading(true);

			const resolvedSrc = await resolveBestThumbnail(videoId, customThumbnail);

			if (cancelled) {
				return;
			}

			setSrc(resolvedSrc);
			setIsLoading(false);
		}

		pickThumbnail();

		return () => {
			cancelled = true;
		};
	}, [videoId, customThumbnail, cacheKey]);

	if (!videoId && !customThumbnail) {
		return <div className="video-help__thumbnail-placeholder">Dodaj link YouTube</div>;
	}

	if (isLoading && !src) {
		return <div className="video-help__thumbnail-placeholder">Ładowanie miniaturki...</div>;
	}

	return (
		<img
			className={className}
			src={src}
			alt={alt}
			loading="lazy"
			decoding="async"
			referrerPolicy="no-referrer"
			width="281"
			height="155"
		/>
	);
}

async function enrichArticlesWithYoutubeData(articles) {
	const normalizedArticles = articles.map(normalizeArticle);
	const apiKey = process.env.YOUTUBE_API_KEY;

	if (!apiKey) {
		return normalizedArticles;
	}

	const videoIds = [
		...new Set(normalizedArticles.map((article) => article.videoId).filter(Boolean)),
	];

	if (videoIds.length === 0) {
		return normalizedArticles;
	}

	try {
		const params = new URLSearchParams({
			part: "snippet,contentDetails",
			id: videoIds.join(","),
			key: apiKey,
		});

		const response = await fetch(
			`https://www.googleapis.com/youtube/v3/videos?${params.toString()}`,
		);

		if (!response.ok) {
			return normalizedArticles;
		}

		const data = await response.json();
		const videosMap = new Map((data.items || []).map((item) => [item.id, item]));

		return normalizedArticles.map((article) => {
			const videoData = videosMap.get(article.videoId);

			if (!videoData) {
				return article;
			}

			const apiDuration = videoData.contentDetails?.duration || "";
			const apiThumbnailUrl = getBestYoutubeThumbnailFromSnippet(videoData.snippet?.thumbnails);
			const apiUploadDate = videoData.snippet?.publishedAt || "";

			return {
				...article,
				duration: article.duration || isoDurationToReadableDuration(apiDuration),
				isoDuration: article.isoDuration || apiDuration || durationToIsoDuration(article.duration),
				thumbnailUrl: article.thumbnailUrl || apiThumbnailUrl,
				uploadDate: article.uploadDate || apiUploadDate,
			};
		});
	} catch {
		return normalizedArticles;
	}
}

export async function getStaticProps() {
	const articles = await enrichArticlesWithYoutubeData(VIDEO_ARTICLES);

	return {
		props: {
			articles,
		},
		revalidate: 86400,
	};
}

export default function PomocVideo({ articles = VIDEO_ARTICLES }) {
	const Miasto = "PRZYJAZNEDEKLARACJE";
	const Podatek = "pomocvideo";

	const normalizedArticles = useMemo(() => {
		return articles.map(normalizeArticle);
	}, [articles]);

	const [activeTag, setActiveTag] = useState(null);

	const visibleArticles = useMemo(() => {
		if (!activeTag) {
			return normalizedArticles;
		}

		return normalizedArticles.filter((article) => article.tags.includes(activeTag));
	}, [activeTag, normalizedArticles]);

	const structuredData = useMemo(() => {
		return buildStructuredData(normalizedArticles);
	}, [normalizedArticles]);

	const handleTagClick = (tagId) => {
		setActiveTag((currentTag) => {
			if (currentTag === tagId) {
				return null;
			}

			return tagId;
		});
	};

	return (
		<>
			<Head>
				<title>Pomoc video – Przyjazne Deklaracje</title>
				<meta
					name="description"
					content="Filmy instruktażowe i artykuły pomocnicze dotyczące formularzy IN-1, DN-1, DT-1 oraz podatków lokalnych."
				/>
				<link rel="canonical" href={PAGE_URL} />

				<meta property="og:type" content="website" />
				<meta property="og:title" content="Pomoc video – Przyjazne Deklaracje" />
				<meta
					property="og:description"
					content="Filmy instruktażowe i artykuły pomocnicze dotyczące formularzy IN-1, DN-1, DT-1 oraz podatków lokalnych."
				/>
				<meta property="og:url" content={PAGE_URL} />

				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: serializeJsonLd(structuredData),
					}}
				/>
			</Head>

			<SectionLayout miasto={Miasto} podatek={Podatek} typeHero="slider" breadcrumbsLayout="light">
				<Section>
					<div className="video-help">
						<div className="video-help__inner">
							<section className="video-help__tags" aria-labelledby="video-help-tags-title">
								<h2 id="video-help-tags-title" className="video-help__tags-title">
									Tagi
								</h2>

								<p id="video-help-tags-description" className="video-help__sr-only">
									Wybierz tag, aby przefiltrować listę filmów. Ponowne kliknięcie aktywnego taga
									usuwa filtr i pokazuje wszystkie filmy.
								</p>

								<ul
									className="video-help__tags-list"
									aria-describedby="video-help-tags-description"
								>
									{VIDEO_TAGS.map((tag) => {
										const isActive = activeTag === tag.id;

										return (
											<li key={tag.id} className="video-help__tag-item">
												<button
													type="button"
													className={`video-help__tag ${isActive ? "video-help__tag--active" : ""}`}
													aria-pressed={isActive}
													aria-controls="video-help-list"
													onClick={() => handleTagClick(tag.id)}
												>
													{tag.label}
												</button>
											</li>
										);
									})}
								</ul>
							</section>

							<section className="video-help__results" aria-labelledby="video-help-results-title">
								<h2 id="video-help-results-title" className="video-help__sr-only">
									Lista filmów pomocy
								</h2>

								<p className="video-help__sr-only" aria-live="polite" aria-atomic="true">
									{activeTag
										? `Wybrano tag ${activeTag}. Liczba wyników: ${visibleArticles.length}.`
										: `Pokazywane są wszystkie filmy. Liczba wyników: ${visibleArticles.length}.`}
								</p>

								<ul id="video-help-list" className="video-help__list">
									{visibleArticles.map((article) => {
										const slug = getSlug(article.fileName);
										const href = `/abc-podatkow/${slug}`;
										const title = getArticleDisplayTitle(article);
										const duration =
											article.duration || isoDurationToReadableDuration(article.isoDuration);

										return (
											<li key={article.fileName} className="video-help__list-item">
												<article className="video-help__card">
													<div className="video-help__thumbnail" aria-hidden="true">
														<ThumbImage
															videoId={article.videoId}
															customThumbnail={article.thumbnailUrl}
															alt=""
															className="video-help__thumbnail-img"
														/>

														{/* {duration ? (
															<span className="video-help__duration">{duration}</span>
														) : null} */}
													</div>

													<div className="video-help__content">
														<h3 className="video-help__title">{title}</h3>

														<p className="video-help__description">{article.description}</p>

														{/* {duration ? (
															<p className="video-help__sr-only">Czas filmu: {duration}.</p>
														) : null} */}

														<Link href={href} legacyBehavior>
															<a
																className="video-help__link"
																aria-label={`Przejdź do artykułu: ${title}`}
															>
																Przejdź
															</a>
														</Link>
													</div>
												</article>
											</li>
										);
									})}
								</ul>
							</section>
						</div>

						<style jsx>{`
							.video-help {
								width: 100%;
								background: #ffffff;
								color: #1f1f1f;
							}

							.video-help__inner {
								width: 100%;
								max-width: 1810px;
								margin: 0 auto;
							}

							.video-help__sr-only {
								position: absolute;
								width: 1px;
								height: 1px;
								padding: 0;
								margin: -1px;
								overflow: hidden;
								clip: rect(0, 0, 0, 0);
								white-space: nowrap;
								border: 0;
							}

							.video-help__tags {
								width: 100%;
								margin: 0 0 48px;
								padding: 32px;
								background: #f8f8f8;
								border-radius: 13px;
							}

							.video-help__tags-title {
								margin: 0;
								font-size: 20px;
								font-weight: 500;
								line-height: 1.25;
								letter-spacing: -0.02em;
								color: #202020;
							}

							.video-help__tags-list {
								display: flex;
								flex-wrap: wrap;
								gap: 15px;
								margin: 35px 0 0;
								padding: 0;
								list-style: none;
							}

							.video-help__tag-item {
								margin: 0;
								padding: 0;
							}

							.video-help__tag {
								display: inline-flex;
								align-items: center;
								justify-content: center;
								min-height: 35px;
								padding: 4px 13px 5px;
								border: 1.5px solid #007bc2;
								border-radius: 999px;
								background: #ffffff;
								color: #007bc2;
								font-family: inherit;
								font-size: 14px;
								font-weight: 400;
								line-height: 1;
								letter-spacing: -0.01em;
								cursor: pointer;
								transition:
									background-color 0.18s ease,
									color 0.18s ease,
									box-shadow 0.18s ease;
							}

							.video-help__tag:hover {
								background: #eaf6fc;
							}

							.video-help__tag:focus-visible,
							.video-help__link:focus-visible {
								outline: 3px solid #111111;
								outline-offset: 4px;
								box-shadow: 0 0 0 6px rgba(0, 123, 194, 0.2);
							}

							.video-help__tag--active,
							.video-help__tag--active:hover {
								background: #007bc2;
								color: #ffffff;
							}

							.video-help__list {
								display: grid;
								gap: 48px;
								margin: 0 0 48px;
								padding: 0;
								list-style: none;
							}

							.video-help__list-item {
								margin: 0;
								padding: 0;
							}

							.video-help__card {
								display: grid;
								grid-template-columns: 281px minmax(0, 1fr);
								align-items: center;
								gap: 33px;
								min-height: 218px;
								padding: 24px;
								background: #ffffff;
								border-radius: 13px;
								box-shadow: 0 16px 35px rgba(0, 0, 0, 0.1);
							}

							.video-help__thumbnail {
								position: relative;
								width: 281px;
								height: 155px;
								overflow: hidden;
								border-radius: 9px;
								background: #007bc2;
							}

							:global(.video-help__thumbnail-img) {
								display: block;
								width: 100%;
								height: 100%;
								object-fit: cover;
							}

							:global(.video-help__thumbnail-placeholder) {
								display: flex;
								align-items: center;
								justify-content: center;
								width: 100%;
								height: 100%;
								padding: 16px;
								background: #007bc2;
								color: #ffffff;
								font-size: 14px;
								line-height: 1.35;
								text-align: center;
							}

							.video-help__duration {
								position: absolute;
								right: 8px;
								bottom: 8px;
								display: inline-flex;
								align-items: center;
								justify-content: center;
								min-width: 38px;
								height: 22px;
								padding: 2px 5px;
								border-radius: 4px;
								background: rgba(0, 0, 0, 0.78);
								color: #ffffff;
								font-size: 13px;
								font-weight: 400;
								line-height: 1;
							}

							.video-help__content {
								min-width: 0;
								padding: 1px 0 0;
							}

							.video-help__title {
								margin: 0 0 24px;
								font-size: 20px;
								font-weight: 500;
								line-height: 1.2;
								letter-spacing: -0.025em;
								color: #222222;
							}

							.video-help__description {
								max-width: 1290px;
								margin: 0 0 24px;
								font-size: 16px;
								font-weight: 400;
								line-height: 1.45;
								letter-spacing: -0.018em;
								color: #333333;
							}

							.video-help__link {
								display: inline-flex;
								align-items: center;
								color: #007bc2;
								font-size: 16px;
								font-weight: 400;
								line-height: 1.2;
								text-decoration: none;
								letter-spacing: -0.018em;
							}

							.video-help__link:hover {
								text-decoration: underline;
							}

							@media (prefers-reduced-motion: reduce) {
								.video-help__tag {
									transition: none;
								}
							}

							@media (max-width: 900px) {
								.video-help__inner {
									padding: 18px 14px 48px;
								}

								.video-help__tags {
									margin-bottom: 36px;
									padding: 28px 22px;
								}

								.video-help__tags-title {
									font-size: 22px;
								}

								.video-help__tags-list {
									gap: 10px;
									margin-top: 24px;
								}

								.video-help__tag {
									min-height: 33px;
									font-size: 16px;
								}

								.video-help__list {
									gap: 28px;
								}

								.video-help__card {
									grid-template-columns: 1fr;
									gap: 22px;
									padding: 22px;
								}

								.video-help__thumbnail {
									width: 100%;
									height: auto;
									aspect-ratio: 281 / 155;
								}

								.video-help__title {
									margin-bottom: 18px;
									font-size: 23px;
								}

								.video-help__description {
									margin-bottom: 18px;
									font-size: 14px;
								}

								.video-help__link {
									font-size: 19px;
								}
							}
						`}</style>
					</div>
				</Section>
			</SectionLayout>
		</>
	);
}
